import { AppLayout } from "../../components/layouts";
import Statistics from "./components/Statistics";
import Welcome from "./components/Welcome";
import Rightnav from "./components/Rightnav";
import { FaWhatsapp } from "react-icons/fa";

// WhatsApp group link (replace with your group's link)
const whatsappLink = "https://chat.whatsapp.com/your-group-link-here";

function Dashboard() {
  return (
    <AppLayout>
      <div className="grid grid-cols-1 md:grid-cols-3 px-4 md:px-0">
        <div className="md:col-span-1 hidden md:block"></div>
        <div className="md:col-span-2 font-['Outfit'] text-3xl md:text-4xl font-medium leading-[40px] md:leading-[50px] text-amber-500 tracking-normal">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed top-4 right-4 z-50 flex items-center justify-center bg-amber-500 text-white p-3 md:p-4 rounded-full shadow-lg hover:bg-amber-600 transition-all"
          >
            <FaWhatsapp size={20} className="md:size-6" />
          </a>
        </div>

        <div className="col-span-full">
          <Welcome />
        </div>
      </div>

      {/* Grid layout */}
      <div className="w-full mt-10 px-4 md:px-0">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          {/* Left Column */}
          <div className="md:col-span-4">
            <Statistics />
          </div>

          {/* Right Column */}
          <div className="md:col-span-2 relative">
            <Rightnav />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default Dashboard;
